export const MEET_LINK_STATUSES = ['pending', 'ready', 'failed'] as const;

export type MeetLinkStatus = (typeof MEET_LINK_STATUSES)[number];

export type BookingLocationAudience = 'client' | 'owner';

export const MEET_GENERIC_LINK_TEXT = 'Google Meeting Link';

export const MEET_VIDEO_CALL_LABEL = 'Video call on Google Meet';

export const MEET_LINK_FAILED_OWNER_NOTE =
  'The Google Meet link could not be created. Add one in Google Calendar and send it to your client.';

export const CUSTOMER_ADDRESS_FALLBACK_TEXT = 'At your address';

export const PHONE_CALL_WORDING: Record<
  BookingLocationAudience,
  (phoneNumber: string) => string
> = {
  client: (phoneNumber) => `You'll receive a call at ${phoneNumber}`,
  owner: (phoneNumber) => `Phone call: ${phoneNumber}`,
};
